module.exports = __webpack_public_path__ + "img/live_tv.271f3ab5.svg";